import React, { createContext, useState } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var LocaleContext = /*#__PURE__*/createContext({
  locale: "en-US",
  setLocale: function setLocale() {
    return null;
  }
});
export var LocaleProvider = function LocaleProvider(_ref) {
  var lang = _ref.lang,
      children = _ref.children;

  var _useState = useState(lang),
      locale = _useState[0],
      setLocale = _useState[1];

  return _jsx(LocaleContext.Provider, {
    value: {
      locale: locale,
      setLocale: setLocale
    },
    children: children
  });
};